import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { LayoutComponent } from 'app/layout/layout.component';
import { authGuard } from './core/auth/guards/auth.guard';
import { StartGuard } from './core/auth/guards/start.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
  {
    path: '',
    canActivate: [StartGuard], // Usa el guard aquí para proteger las rutas de instalación y sign-in
    // Otras configuraciones para esta ruta...
    children: []
  },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

    // Auth routes for guests
    {
        path: '',
        // canActivate: [NoAuthGuard],
        // canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') },
            { path: 'installation', loadChildren: () => import('app/modules/auth/installation/installation.routes') },
            { path: 'public-prescription', loadChildren: () => import('app/modules/components/public-inform-consumption/public-inform-consumption.routes') },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
        ]
    },

    // Components routes
    {
        path: '',
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/components/home/home.routes') },
            { path: 'settings', loadChildren: () => import('app/modules/components/settings/settings.routes') },
            { path: 'tickets', loadChildren: () => import('app/modules/components/tickets/tickets.routes') },
            { path: 'help-center', loadChildren: () => import('app/modules/components/help-center/help-center.routes') },
            { path: 'afilliate', loadChildren: () => import('app/modules/components/afilliate/afilliate.routes') },
            { path: 'providers', loadChildren: () => import('app/modules/components/providers/providers.routes') },
        ]
    }
];